module.exports = __webpack_public_path__ + "static/media/12.78b09318.png";